import { useState } from "react";
import { useTranslation } from "react-i18next";
import UtilMethods from "../../util/UtilMethods";
import { sendEmail } from "../../services/EmailSender";
import { updateSubscriptions } from "../../services/AdminServices";
import { FaBell, FaUser, FaEnvelope, FaMap, FaLanguage, FaInfoCircle } from "react-icons/fa";
import { REGIONS, LANGUAGES, COUNTRY_OF_ORIGIN_OPTIONS } from "../common/Constants"
import { useEffect } from "react";

export default function SubscriptionForm() {
  const { t, i18n } = useTranslation("labels");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [email, setEmail] = useState("");
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [status, setStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [language, setLanguage] = useState(i18n.language || "en");
  const [showTooltip, setShowTooltip] = useState(false);
  const [showLanguageTooltip, setShowLanguageTooltip] = useState(false);
  const [ageConfirmed, setAgeConfirmed] = useState(false);

  useEffect(() => {
    //console.log("Language" , language);
    //console.log("Updating subscription form language to", i18n.language);
    setLanguage(i18n.language || "en");
    //console.log("Language" , language);
  }, [i18n.language]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showTooltip && !event.target.closest('.tooltip-container')) {
        setShowTooltip(false);
      }
      if (showLanguageTooltip && !event.target.closest('.tooltip-container-lang')) {
        setShowLanguageTooltip(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [showTooltip, showLanguageTooltip]);


  const handleSubmit = async (e) => {
    const subscriptions = {
      firstName,
      lastName,
      phone,
      countryOfOrigin,
      email,
      regions: selectedRegions,
      lang: language,
      createdAt: new Date().toISOString(),
      status: "active",
      ageConfirmed,
      unSubscribeURL: `${process.env.REACT_APP_URL}/unsubscribe/${encodeURIComponent(email)}`,
    };
    console.log("Submitting subscription form", subscriptions);

    e.preventDefault();

    if (!UtilMethods.validateEmail(email)) {
      setStatus("error");
      setErrorMessage(t("subscription.error"));
      return;
    } else if (selectedRegions.length === 0) {
      setStatus("error");
      setErrorMessage(t("subscription.error"));
      return;
    } else if (!firstName || !lastName) {
      setStatus("error");
      setErrorMessage(t("subscription.error"));
      return;
    } else if (!ageConfirmed) {
      setStatus("error");
      setErrorMessage(t("subscription.ageConfirmError"));
      return;
    } else { setStatus(null); }


    try {
      await updateSubscriptions(subscriptions);
      subscriptions.unSubscribeURL = `${process.env.REACT_APP_URL}/unsubscribe/${encodeURIComponent(email)}`;
      // sendEmail(subscriptions);
      console.log("Subscription form updated successfully");
      setStatus("success");
      setFirstName("");
      setLastName("");
      setPhone("");
      setCountryOfOrigin("");
      setEmail("");
      setSelectedRegions([]);
      setAgeConfirmed(false);
    } catch (error) {
      console.error("Error updating subscription form", error);
      setStatus("error");
      setErrorMessage(t("subscription.apiError"));
    }


  };

  return (
    <section className="mrc-wrapper" id="subscribe">
      <div className="mrc-left">
        <h1 >{t("subscription.title")}</h1>
        <p>{t("subscription.subtitle")}</p>
      </div>

      <form className="mrc-form" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', columnGap: '10px', rowGap: '0', flexWrap: 'wrap' }}>
          <div className="input-with-icon" style={{ flex: '1 1 calc(50% - 5px)', minWidth: '250px' }}>
            <span className="input-icon">
              <FaUser />
            </span>
            <input
              placeholder={t("subscription.firstName")}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </div>
          <div className="input-with-icon" style={{ flex: '1 1 calc(50% - 5px)', minWidth: '250px' }}>
            <span className="input-icon">
              <FaUser />
            </span>
            <input
              placeholder={t("subscription.lastName")}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="input-with-icon">
          <span className="input-icon">
            <FaEnvelope />
          </span>
          <input
            placeholder={t("subscription.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div style={{ display: 'flex', columnGap: '10px', rowGap: '0', flexWrap: 'wrap' }}>
          <div className="input-with-icon" style={{ flex: '1 1 calc(50% - 5px)', minWidth: '200px', position: 'relative' }}>
            <span className="input-icon">
              <FaUser />
            </span>
            <select
              value={countryOfOrigin}
              onChange={(e) => setCountryOfOrigin(e.target.value)}
              style={{ paddingRight: '35px' }}
            >
              <option value="">{t("subscription.countryOfOrigin")}</option>
              {COUNTRY_OF_ORIGIN_OPTIONS.map((country) => (
                <option key={country.value} value={country.value}>
                  {country.label}
                </option>
              ))}
            </select>
            <div className="tooltip-container" style={{ display: 'inline-block' }}>
              <FaInfoCircle
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#fff',
                  cursor: 'pointer',
                  fontSize: '18px',
                  zIndex: 1
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowTooltip(!showTooltip);
                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              />
              {showTooltip && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#333',
                    color: '#fff',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    fontSize: '13px',
                    whiteSpace: 'normal',
                    width: 'max-content',
                    maxWidth: '280px',
                    marginBottom: '5px',
                    zIndex: 1000,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                    lineHeight: '1.4'
                  }}
                >
                  {t("subscription.countryOfOriginPlaceholder")}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '-5px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: 0,
                      height: 0,
                      borderLeft: '5px solid transparent',
                      borderRight: '5px solid transparent',
                      borderTop: '5px solid #333'
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="input-with-icon" style={{ flex: '1 1 calc(50% - 5px)', minWidth: '200px', position: 'relative' }}>
            <span className="input-icon">
              <FaLanguage />
            </span>
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              style={{ paddingRight: '35px' }}
            >
              <option value="">{t("subscription.language")}</option>
              {LANGUAGES.map((lang) => (
                <option key={lang.value} value={lang.value}>
                  {lang.label}
                </option>
              ))}
            </select>
            <div className="tooltip-container-lang" style={{ display: 'inline-block' }}>
              <FaInfoCircle
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#fff',
                  cursor: 'pointer',
                  fontSize: '18px',
                  zIndex: 1
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowLanguageTooltip(!showLanguageTooltip);
                }}
                onMouseEnter={() => setShowLanguageTooltip(true)}
                onMouseLeave={() => setShowLanguageTooltip(false)}
              />
              {showLanguageTooltip && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#333',
                    color: '#fff',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    fontSize: '13px',
                    whiteSpace: 'normal',
                    width: 'max-content',
                    maxWidth: '280px',
                    marginBottom: '5px',
                    zIndex: 1000,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                    lineHeight: '1.4'
                  }}
                >
                  {t("subscription.languagePlaceholder")}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '-5px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: 0,
                      height: 0,
                      borderLeft: '5px solid transparent',
                      borderRight: '5px solid transparent',
                      borderTop: '5px solid #333'
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="region-box">
          <div className="region-options">
            <span className="input-icon" title={t("subscription.region")} style={{ cursor: 'help' }}>
              <FaMap />
            </span>
            {/*
            <label>
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={(e) =>
                  setSelectedRegions(e.target.checked ? REGIONS : [])
                }
              />
              {t("subscription.all")}
            </label>
*/ }
            {REGIONS.map((r) => (
              <label key={r.value}>
                <input
                  type="checkbox"
                  checked={selectedRegions.includes(r.value)}
                  onChange={(e) =>
                    setSelectedRegions((s) =>
                      e.target.checked
                        ? [...s, r.value]
                        : s.filter((x) => x !== r.value)
                    )
                  }
                />
                {r.label}
              </label>
            ))}
          </div>
        </div>

        <div className="age-confirm-box">
          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '13px',
            gap: '5px'
          }}>
            <input
              type="checkbox"
              checked={ageConfirmed}
              onChange={(e) => setAgeConfirmed(e.target.checked)}
              style={{
                marginTop: '1px',
                cursor: 'pointer',
                width: '16px',
                height: '16px',
                minWidth: '16px',
                flexShrink: 0
              }}

            />
            <span style={{ flex: 1, lineHeight: '1.5' }}>{t("subscription.ageConfirm")}</span>
          </label>
        </div>

        <button type="submit" className="subscribe-btn mt-1 mb-1">
          <FaBell />
          <span>{t("subscription.send")}</span>
        </button>


        {status === "success" && (
          <p className="success">{t("subscription.success")}</p>
        )}
        {status === "error" && (
          <p className="error">{errorMessage}</p>
        )}
      </form>
    </section>
  );
}
